import { cn } from '@forest/shared'

export function CloseButton(props: {
  className?: string
  onClick?: () => void
}) {
  return (
    <button
      className={cn('size-[42px]', props.className)}
      onClick={props.onClick}
    >
      <svg
        width="42"
        height="42"
        viewBox="0 0 42 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="pointer-events-none rounded-full bg-white/80 backdrop-blur"
      >
        <g data-figma-bg-blur-radius="87.5">
          <rect
            x="0.875"
            y="0.875"
            width="40.25"
            height="40.25"
            rx="20.125"
            stroke="url(#paint0_linear_20963_53142)"
            strokeWidth="1.75"
          />
          <path
            d="M16 16L25.9999 25.9999"
            stroke="#333333"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />

          <path
            d="M16.0001 25.9999L26 16"
            stroke="#333333"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <linearGradient
            id="paint0_linear_20963_53142"
            x1="22.4882"
            y1="-7.88143e-07"
            x2="34.3401"
            y2="38.3359"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" stopOpacity="0.3" />
            <stop offset="1" stopColor="white" stopOpacity="0.1" />
          </linearGradient>
        </defs>
      </svg>
    </button>
  )
}
